// Hand-written companion to the auto-generated `client.ts`. Calls the Java self-sign-up-api
// directly via the connect nginx-backend rewrite (CPG-787).
//
// The relative path `/api/self-sign-up/venue/validate/business-name` resolves against the SPA's
// current origin (the connect domain, where treatwell-nginx-backend rewrites `/api/self-sign-up/`
// to the Java `/external-api/` path).

import { mockValidateBusinessName } from './api-mock';
import { useMock } from './utils';

// Raw per-entity availability. The business name is used as both the supplier name and the venue
// name, so both are checked; the caller decides overall availability and does the append-the-city
// retry that the old creation flow did. Java returns an extra `reasons` field; we ignore it.
export type ValidateBusinessNameResponse = {
  supplier: { canCreate: boolean };
  venue: { canCreate: boolean };
};

const AVAILABLE: ValidateBusinessNameResponse = {
  supplier: { canCreate: true },
  venue: { canCreate: true },
};

// ISO-3166-1 alpha-2 → Treatwell country ID. Ported from the now-removed TS proxy's
// countries util; Java expects `countryId`.
const COUNTRY_ID_BY_CODE: Record<string, number> = {
  AL: 17,
  AD: 20,
  AT: 28,
  BY: 34,
  BE: 35,
  BA: 41,
  BG: 46,
  HR: 67,
  CY: 69,
  CZ: 70,
  DK: 71,
  EE: 81,
  FI: 86,
  FR: 87,
  DE: 94,
  GI: 96,
  GR: 97,
  HU: 109,
  IS: 110,
  IE: 115,
  IT: 117,
  LV: 127,
  LI: 132,
  LT: 133,
  LU: 134,
  MK: 136,
  MT: 142,
  MD: 150,
  MC: 151,
  ME: 16626,
  NL: 160,
  NO: 171,
  PL: 181,
  PT: 182,
  RO: 186,
  SM: 190,
  RS: 16625,
  SK: 198,
  SI: 199,
  ES: 205,
  SE: 215,
  CH: 216,
  TR: 227,
  UA: 232,
  GB: 234,
  VA: 239,
};

export async function validateBusinessName(
  businessName: string,
  countryCode: string,
  token: string,
): Promise<ValidateBusinessNameResponse> {
  if (useMock) {
    return mockValidateBusinessName(businessName);
  }
  const res = await fetch('/api/self-sign-up/venue/validate/business-name', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: businessName,
      countryId: COUNTRY_ID_BY_CODE[countryCode],
      token,
    }),
  });
  if (!res.ok) {
    // Includes 401 (captcha rejected), 429 and 5xx — treat as fail-open so a transient blip or
    // a stale token can't block submission. Final submit re-validates and is authoritative.
    return AVAILABLE;
  }
  return (await res.json()) as ValidateBusinessNameResponse;
}
